// src/PhoneAlt.tsx
import * as React from "react";
var PhoneAlt = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size * 1.25,
    height: props.size,
    viewBox: "0 0 20 16",
    fill: props.color,
    style: props.style,
    role: props.role,
    className: props.className
  },
  /* @__PURE__ */ React.createElement("path", { d: "m15.63 10.63-1.98-.23c-.48-.05-.94.11-1.28.44l-1.43 1.43A11.592 11.592 0 0 1 5.8 7.14L7.24 5.7c.34-.34.5-.8.44-1.28l-.22-1.96c-.09-.79-.76-1.38-1.55-1.38H4.56c-.88 0-1.61.73-1.56 1.61.41 6.66 5.74 11.97 12.38 12.38.89.06 1.62-.67 1.62-1.55v-1.35c.01-.79-.58-1.45-1.37-1.54z" })
);
PhoneAlt.displayName = "PhoneAlt";
export {
  PhoneAlt
};
